
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class PendingOrderProductsGrid extends Serenity.EntityGrid<PendingOrderProductsRow, any> {
        protected getColumnsKey() { return PendingOrderProductsColumns.columnsKey; }
        protected getDialogType() { return PendingOrderProductsDialog; }
        protected getIdProperty() { return PendingOrderProductsRow.idProperty; }
        protected getInsertPermission() { return PendingOrderProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return PendingOrderProductsRow.localTextPrefix; }
        protected getService() { return PendingOrderProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}